/**
 * 前端密码加密工具
 */

/**
 * AES加密
 */


import CryptoJS from 'crypto-js';

let aes_key = "ywg_invengo_prod";

function AesEncode(str, input_key = "") {
    if (input_key !== "") {
        aes_key = input_key;
    }
    const keyBytes = CryptoJS.enc.Utf8.parse(aes_key);
    const ivBytes = CryptoJS.enc.Utf8.parse(aes_key);
    const encrypted = CryptoJS.AES.encrypt(str, keyBytes, { iv: ivBytes, mode: CryptoJS.mode.CBC });
    return encrypted.toString();
}

function AesDecode(str, input_key = "") {
    if (input_key !== "") {
        aes_key = input_key;
    }
    const keyBytes = CryptoJS.enc.Utf8.parse(aes_key);
    const ivBytes = CryptoJS.enc.Utf8.parse(aes_key);
    const decrypted = CryptoJS.AES.decrypt(str, keyBytes, { iv: ivBytes, mode: CryptoJS.mode.CBC });
    return decrypted.toString(CryptoJS.enc.Utf8);
}

export {
    AesEncode,
    AesDecode
}

